(function(){
/* the home sections each include this file; run it once (security review 22 Oct), except in the theme editor where sections reload */
if(window.__wwHome&&!(window.Shopify&&Shopify.designMode))return;window.__wwHome=1;
var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
var pad=function(n){return (n<10?'0':'')+n};

/* hero video */
document.querySelectorAll('.wh .hero').forEach(function(h){
 var v=h.querySelector('video'),b=h.querySelector('.hctl');if(!v){if(b)b.hidden=true;return}
 v.muted=true;v.setAttribute('playsinline','');
 if(rm){v.pause();v.removeAttribute('autoplay');h.classList.add('paused')}
 else{var p=v.play();if(p&&p.catch)p.catch(function(){h.classList.add('paused')})}
 b&&b.addEventListener('click',function(){if(v.paused){v.play();h.classList.remove('paused');b.setAttribute('aria-label','Pause background video')}else{v.pause();h.classList.add('paused');b.setAttribute('aria-label','Play background video')}});
});

/* product carousels */
document.querySelectorAll('.wh [data-car]').forEach(function(s){
 var t=s.querySelector('.car'),pv=s.querySelector('[data-prev]'),nx=s.querySelector('[data-next]');if(!t)return;
 var step=function(){var c=t.children[0];return c?c.getBoundingClientRect().width+16:t.clientWidth};
 var upd=function(){if(pv)pv.disabled=t.scrollLeft<4;if(nx)nx.disabled=t.scrollLeft+t.clientWidth>=t.scrollWidth-4};
 pv&&pv.addEventListener('click',function(){t.scrollBy({left:-step(),behavior:rm?'auto':'smooth'})});
 nx&&nx.addEventListener('click',function(){t.scrollBy({left:step(),behavior:rm?'auto':'smooth'})});
 t.addEventListener('scroll',upd,{passive:true});addEventListener('resize',upd);upd();
});

/* process slider */
document.querySelectorAll('.wh [data-proc]').forEach(function(s){
 var t=s.querySelector('.ptrack'),sl=Array.prototype.slice.call(t.children),n=sl.length,i=-1;if(!n)return;
 var num=s.querySelectorAll('[data-num]'),tl=s.querySelector('[data-title]'),tx=s.querySelector('[data-text]'),bar=s.querySelector('[data-prog]');
 var set=function(k){if(k===i)return;i=k;var d=sl[k].dataset;num.forEach(function(e){e.textContent=pad(k+1)});if(tl)tl.textContent=d.t;if(tx)tx.textContent=d.d;if(bar)bar.style.width=((k+1)/n*100)+'%';sl.forEach(function(e,j){e.classList.toggle('on',j===k)})};
 var w=function(){return sl[0].getBoundingClientRect().width+16};
 var go=function(k){k=(k+n)%n;t.scrollTo({left:k*w(),behavior:rm?'auto':'smooth'});set(k)};
 var lock=0;
 t.addEventListener('scroll',function(){if(Date.now()-lock<600)return;var k=Math.round(t.scrollLeft/w());if(k>=0&&k<n)set(k)},{passive:true});
 s.querySelector('[data-pprev]').addEventListener('click',function(){lock=Date.now();go(i-1)});
 s.querySelector('[data-pnext]').addEventListener('click',function(){lock=Date.now();go(i+1)});
 sl.forEach(function(e,j){e.addEventListener('click',function(){lock=Date.now();go(j)})});
 set(0);
});
})();